const objectFilter = (accepted_keys = []) => (obj) => {
  let result = accepted_keys.reduce((carry, key) => ({ ...carry, [key]: obj[key] }), {});
  Object.keys(result).forEach(key => typeof result[key] === 'undefined' && delete result[key]);
  return result;
}

export default objectFilter;

